import {PrintData} from "./print-data";
import {urlToBase64} from "./url-to-base64";

/**
 * (PDF) 송장 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'PDF방식 송장출력',

    makeQzDataPromise: (house_id, blno, printer) => {
        //let url = '/printer-guide/qz-sample.pdf';
        //url = '/houses/1038393/bl?__accept=pdf&outline=no'; // 일본항공
        //url = '/houses/1038714/bl?__accept=pdf&outline=no'; // 미국

        // pdf 아웃라인 결정
        let outline = 'no';
        if (printer && printer.label) {
            outline = printer.label.emptyLine ? 'yes' : 'no';
        }

//console.log(printer.label);
        let url = `/houses/${house_id}/bl?__accept=pdf&outline=${outline}&`;
        if (blno) {
            url += `blno=${blno}`;
        }

        return urlToBase64(url)
            .then((base64) => {
                return new Promise((resolve, reject) => {
                    let data = [{
                        type: 'pixel',
                        format: 'pdf',
                        flavor: 'base64',
                        data: base64,
                        options: { ignoreTransparency: true }
                    }];
                    resolve(data);

                    console.log('pdf 송장 데이터 생성완료!');

                });
            });


    },
})